import { render, staticRenderFns } from "./MeetGreetStart.vue?vue&type=template&id=71828f78&"
import script from "./MeetGreetStart.vue?vue&type=script&lang=js&"
export * from "./MeetGreetStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports